var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-expand-control"},[_c('span',{staticClass:"text-wrap",class:{ expand: _vm.isExpand },on:{"click":_vm.handleExpandOrder}},[(!_vm.onlyShowIcon)?_c('span',[_vm._v(_vm._s(_vm.isExpand ? _vm.closeText : _vm.expandText))]):_vm._e(),_c('i',{staticClass:"el-icon-arrow-down"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }